import { Heading01 } from 'module/ui/components/styles';
import { WebsiteContent } from 'api/knowledge-base/types';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { WebsiteFoldersGrid } from './grid';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-03);
  height: 100%;
`;
const Label = styled.div`
  ${Heading01};
`;

interface Props {
  onSelectionChange: (selectedItemInfos: WebsiteContent[]) => void;
  data: WebsiteContent[];
  apiDocVersion: boolean;
}
export const FoldersChooser: FC<Props> = ({
  onSelectionChange,
  data,
  apiDocVersion,
}) => {
  const handleSelectionChange = (selectedItemInfos: WebsiteContent[]) => {
    onSelectionChange?.(selectedItemInfos);
  };

  return (
    <Wrapper>
      <Label>
        <FormattedMessage id="knowledge_base.add_website.folders.label" />
      </Label>
      <WebsiteFoldersGrid
        data={data}
        onSelectionChange={handleSelectionChange}
        apiDocVersion={apiDocVersion}
      />
    </Wrapper>
  );
};
